const Blank = () => <div>This is a blank page</div>;

export default Blank;
